const PUBLISHED_JOB_PROFILES_ROUTE = 'published-job-profiles';

const LEGACY_COMPARE_FROM = {
  'hris-job-profiles': PUBLISHED_JOB_PROFILES_ROUTE,
};

const LIBRARY_COMPARE_FROM = {
  'draft-job-profiles': {
    backTo: { name: 'draft-job-profiles' },
    label: 'Draft Job Profiles',
  },
  [PUBLISHED_JOB_PROFILES_ROUTE]: {
    backTo: { name: PUBLISHED_JOB_PROFILES_ROUTE },
    label: 'Published Job Profiles',
  },
  'job-architecture': {
    backTo: { name: 'job-architecture', query: { view: 'list' } },
    label: 'Job Architecture',
  },
};

const buildEditorCompareFrom = (hrisName) => ({
  'job-profile-view': {
    label: 'Draft Job Profile',
  },
  'job-profile-hris-view': {
    label: `${hrisName} Job Profile`,
  },
});

const EDITOR_COMPARE_FROM_KEYS = ['job-profile-view', 'job-profile-hris-view'];

export const isEditorCompareFrom = (from) => EDITOR_COMPARE_FROM_KEYS.includes(from);

// Pick the compare page back link. If we came from an editor with an id, go back there.
export const resolveCompareBreadcrumb = ({
  from,
  fromId,
  hrisUlids = [],
  draftUlids = [],
  hrisName,
} = {}) => {
  const libraryFrom = LEGACY_COMPARE_FROM[from] ?? from;
  const editorCompareFrom = buildEditorCompareFrom(hrisName);

  if (isEditorCompareFrom(from) && fromId) {
    return {
      from,
      label: editorCompareFrom[from].label,
      backTo: {
        name: from,
        params: { id: fromId },
      },
    };
  }

  const noSelection = hrisUlids.length === 0 && draftUlids.length === 0;

  if (noSelection) {
    const fallbackFrom = LIBRARY_COMPARE_FROM[libraryFrom] ? libraryFrom : 'job-architecture';

    return {
      from: fallbackFrom,
      ...LIBRARY_COMPARE_FROM[fallbackFrom],
    };
  }

  const isDraftOnly = hrisUlids.length === 0 && draftUlids.length > 0;
  const isHrisOnlyFromLibrary = hrisUlids.length > 0
    && draftUlids.length === 0
    && libraryFrom === PUBLISHED_JOB_PROFILES_ROUTE;

  let resolvedFrom = 'job-architecture';

  if (isDraftOnly) resolvedFrom = 'draft-job-profiles';
  else if (isHrisOnlyFromLibrary) resolvedFrom = PUBLISHED_JOB_PROFILES_ROUTE;

  return {
    from: resolvedFrom,
    ...LIBRARY_COMPARE_FROM[resolvedFrom],
  };
};
